import { render, staticRenderFns } from "./other.vue?vue&type=template&id=47bde4e2&scoped=true&"
var script = {}
import style0 from "./other.vue?vue&type=style&index=0&id=47bde4e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bde4e2",
  null
  
)

export default component.exports